import React from 'react';
import { DATE_RANGE_PRESETS } from '../../lib/analyticsPresets';

export function DateRangeChips({ activeId, onChange }) {
  return (
    <div className="analytics-date-chips d-flex flex-wrap gap-2" role="group" aria-label="Date range">
      {DATE_RANGE_PRESETS.map((preset) => (
        <button
          key={preset.id}
          type="button"
          className={`analytics-date-chip${activeId === preset.id ? ' is-active' : ''}`}
          onClick={() => onChange(preset.id)}
          aria-pressed={activeId === preset.id}
        >
          {preset.label}
        </button>
      ))}
    </div>
  );
}
